module.exports = __webpack_public_path__ + "static/media/plus-icon.a64fb69b.svg";